import { render, staticRenderFns } from "./AddSectionComponent.vue?vue&type=template&id=3c01a29c&"
import script from "./AddSectionComponent.vue?vue&type=script&lang=js&"
export * from "./AddSectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c01a29c')) {
      api.createRecord('3c01a29c', component.options)
    } else {
      api.reload('3c01a29c', component.options)
    }
    module.hot.accept("./AddSectionComponent.vue?vue&type=template&id=3c01a29c&", function () {
      api.rerender('3c01a29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/AddSectionComponent.vue"
export default component.exports